import { emitRecoAddToCartButtonLabelEvent } from "./eventEmitter";

const buildCinema = (cinemaTracking) => {
    return {
        ...cinemaTracking,
    };
};

export default (cinemaTracking) => {
    const event = {
        name: "scroll",
        features: [buildCinema(cinemaTracking)],
    };

    emitRecoAddToCartButtonLabelEvent({ promo_RecoAddToCartButton: "visible" }, event);
};
